import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { FooterComponent } from './components/footer/footer.component'
import { TopNavComponent } from './components/top-nav/top-nav.component'

@Component({
    selector: 'endevelo-root',
    standalone: true,
    imports: [RouterOutlet, TopNavComponent, FooterComponent],
    template: `
        <endevelo-top-nav></endevelo-top-nav>
        <main class="flex-grow">
            <router-outlet></router-outlet>
        </main>
        <endevelo-footer></endevelo-footer>
    `
})
export class AppComponent {}
